export default theme => ({
  imageCarouselOuter: {
    overflowX: 'auto',
    borderRadius: 5,
  },

  imageCarouselOuterVertical: {
    overflowX: 'hidden',
    overflowY: 'auto',
  },

  imageCarouselInner: {
    display: 'flex',
    overflowY: 'hidden',
    paddingTop: 10,
    paddingLeft: 15,
    float: 'left',
  },

  imageCarouselInnerVertical: {
    flexDirection: 'column',
  },

  imageCarouselTile: {
    position: 'relative',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },

  imageCarouselTileVertical: {
    marginTop: 15,
  },

  imageCarouselImage: {
    width: 'auto',
    maxWidth: 200,
    height: '95%',
    position: 'relative',
    display: 'inline-block',
    borderRadius: 5,
  },

  imageCarouselImageWithHiddenVisibility: {
    background: 'rgba(0,0,0,0.4)',
  },
  imageCarouselImageWithFraudulentIndicator: {
    background: 'rgba(0,0,0,0.4)',
  },

  imageCarouselImageVertical: {
    maxWidth: 'unset',
    width: '100%',
  },

  imageCarouselImageWithDeleteIcon: {
    maxHeight: '70%',
  },
  hiddenImageOverlay: {
    position: 'absolute',
    top: 0,
    right: 0,
    left: 0,
    borderRadius: 5,
    height: '95%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: 'white',
    cursor: 'pointer',
    zIndex: 1,
  },
  hiddenImageOverlayWithDeleteIcon: {
    maxHeight: '70%',
  },
});
